import { render } from "./MetricsPage.vue?vue&type=template&id=e5070434&scoped=true"
import script from "./MetricsPage.vue?vue&type=script&lang=js"
export * from "./MetricsPage.vue?vue&type=script&lang=js"

import "./MetricsPage.vue?vue&type=style&index=0&id=e5070434&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5070434"]])

export default __exports__